/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ListingResponse,
} from '../models';

export interface ListingApiControllerGetListingDetailRequest {
    xApiKey: string;
    listingId: string;
}

/**
 * 
 */
export class ListingApi extends runtime.BaseAPI {

    /**
     */
    async listingApiControllerGetListingDetailRaw(requestParameters: ListingApiControllerGetListingDetailRequest): Promise<runtime.ApiResponse<ListingResponse>> {
        if (requestParameters.xApiKey === null || requestParameters.xApiKey === undefined) {
            throw new runtime.RequiredError('xApiKey','Required parameter requestParameters.xApiKey was null or undefined when calling listingApiControllerGetListingDetail.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling listingApiControllerGetListingDetail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
            headerParameters['x-api-key'] = String(requestParameters.xApiKey);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/listings/{listingId}`.replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async listingApiControllerGetListingDetail(requestParameters: ListingApiControllerGetListingDetailRequest): Promise<ListingResponse> {
        const response = await this.listingApiControllerGetListingDetailRaw(requestParameters);
        return await response.value();
    }

}
